import { render, staticRenderFns } from "./dictionaryManage.vue?vue&type=template&id=2ea1e732&scoped=true"
import script from "./dictionaryManage.vue?vue&type=script&lang=js"
export * from "./dictionaryManage.vue?vue&type=script&lang=js"
import style0 from "./dictionaryManage.vue?vue&type=style&index=0&id=2ea1e732&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"
import style1 from "./dictionaryManage.vue?vue&type=style&index=1&id=2ea1e732&prod&lang=css"
import style2 from "./dictionaryManage.vue?vue&type=style&index=2&id=2ea1e732&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"
import style3 from "./dictionaryManage.vue?vue&type=style&index=3&id=2ea1e732&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea1e732",
  null
  
)

export default component.exports